/** Flags de producto. KYC está apagado: Credit Now no lo opera. */
export const FEATURES = {
  kyc: import.meta.env.VITE_KYC_ENABLED === 'true',
} as const;
